import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL, API_ENDPOINTS } from "../config/apiconfig";
import "../style/Login.css";
import { TokenManager } from "../utils/tokenManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const LOGIN_API = `${BASE_URL}${API_ENDPOINTS.AUTH.LOGIN}`;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Username and password are required");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(LOGIN_API, {
        username,
        password,
      });

      TokenManager.setToken(response.data.token);

      toast.success("Login successful ");

      setTimeout(() => {
        navigate("/dashboard");
      }, 1200);
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sc-login-wrapper">
      <div className="sc-login-card">
        <h2 className="sc-login-title">CTM Login</h2>

        <form onSubmit={handleSubmit} className="sc-login-form">
          {/* Username */}
          <div className="sc-field-group">
            <label className="sc-label">Username</label>
            <div className="sc-input-box">
              <FontAwesomeIcon icon={faUser} className="sc-left-icon" />
              <input
                type="text"
                className="sc-input"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="sc-field-group">
            <label className="sc-label">Password</label>
            <div className="sc-input-box">
              <FontAwesomeIcon icon={faLock} className="sc-left-icon" />
              <input
                type={showPassword ? "text" : "password"}
                className="sc-input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                className="sc-right-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="sc-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Login;